import React from "react";
import { contact } from "../mock";
import MMLogo from "./MMLogo";
import { ArrowRight, MessageCircle, Instagram } from "lucide-react";

const Hero = () => {
  const scrollToTarifs = () => {
    document.getElementById("tarifs")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen w-full overflow-hidden flex items-center justify-center pt-28 pb-16"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/27544684/pexels-photo-27544684.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600"
          alt="Maison Morgane"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-cream/40 via-cream/20 to-cream/60" />
      </div>

      {/* Content Card */}
      <div className="relative z-10 w-full max-w-2xl mx-4 md:mx-6">
        <div className="bg-cream/95 backdrop-blur-sm border border-gold/20 px-8 py-14 md:px-16 md:py-16 shadow-[0_30px_80px_-30px_rgba(93,74,50,0.4)] soft-fade text-center">
          <div className="flex justify-center mb-6">
            <MMLogo size={72} />
          </div>

          <p className="font-serif text-[10px] md:text-[11px] tracking-[0.4em] text-brown mb-6 uppercase">
            Institut Privé &nbsp;•&nbsp; {contact.city}
          </p>
          <p className="font-cormorant italic text-brown/70 text-sm mb-6">
            {contact.address} — 5580 {contact.city}
          </p>

          <h1 className="font-serif text-4xl md:text-6xl text-dark-brown leading-tight tracking-wide mb-6">
            Maison Morgane
          </h1>

          <div className="gold-divider my-6">
            <span className="w-1 h-1 rounded-full bg-gold" />
          </div>

          <p className="font-cormorant text-brown/85 text-lg md:text-xl leading-relaxed mb-10 max-w-md mx-auto">
            Beauté, cosmétique et soins. Un cocon discret où l'on prend soin de vous avec expertise, précision et douceur.
          </p>

          <button
            onClick={scrollToTarifs}
            className="w-full md:w-auto bg-dark-brown text-cream px-12 py-4 tracking-[0.35em] text-xs uppercase font-serif hover:bg-brown transition-colors duration-500 inline-flex items-center justify-center gap-3 group mb-4"
            style={{ backgroundColor: "#2A1F14", color: "#F8F3EC" }}
          >
            <span>Prestations & Tarifs</span>
            <ArrowRight size={14} strokeWidth={1.4} className="group-hover:translate-x-1 transition-transform" />
          </button>

          <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
            <a
              href={contact.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-outline-gold"
            >
              <MessageCircle size={14} strokeWidth={1.6} />
              WhatsApp
            </a>
            <a
              href={contact.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-outline-gold"
            >
              <Instagram size={14} strokeWidth={1.6} />
              Instagram
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
